import { createAction, handleActions } from 'redux-actions';

const setSorting = createAction("SCREENS/SUBBIES/SUBCONTRACTORS/SET_SORTING");

const defaultState = {
  columnKey: 'name',
  order: 'ascend'
};

const reducer = handleActions(
  {
    [setSorting]: (state, action) => Object.assign({}, state, action.payload)
  },
  defaultState
);

export { setSorting, reducer };